import numeral from 'numeral';

export const formatMoneyExport = (
  number: number | undefined,
  currencySymbol = '£',
  isExcludeCurrencySymbol = false,
) => {
  if (number && numeral(number).format('0,0.00') !== 'NaN') {
    if (isExcludeCurrencySymbol) {
      return numeral(number).format('0,0.00');
    }
    return `${currencySymbol} ${numeral(number).format('0,0.00')}`;
  }
  if (isExcludeCurrencySymbol) {
    return '0.00';
  }
  return `${currencySymbol} 0.00`;
};

export const formatMoney = (number: number, currencySymbol = '£') => {
  if (number && numeral(number).format('0,0.00') !== 'NaN') {
    return `${currencySymbol} ${numeral(number).format('0,0.00')}`;
  }
  if (number === 0) {
    return `${currencySymbol} 0.00`;
  }
  return '_';
};

// Same as formatMoney but with a configurable number of decimals (default 4),
// e.g. for rate values like the effective NMW rate that need more precision.
export const formatMoneyWithDecimals = (
  number: number,
  decimals = 4,
  currencySymbol = '£',
) => {
  const fmt = `0,0.${'0'.repeat(decimals)}`;
  if (number && numeral(number).format(fmt) !== 'NaN') {
    return `${currencySymbol} ${numeral(number).format(fmt)}`;
  }
  if (number === 0) {
    return `${currencySymbol} ${numeral(0).format(fmt)}`;
  }
  return '_';
};

export const toNumber = (value: string | number | undefined | null): number => {
  if (value === null || value === undefined || value === '') {
    return 0;
  }

  if (typeof value === 'number') {
    return isNaN(value) ? 0 : value;
  }

  if (typeof value === 'string') {
    // NX-3941: strip currency symbols (£/$/€), thousand separators and
    // whitespace before parsing, so formatted strings like "£1,500" aren't
    // truncated by parseFloat (which stops at the first symbol → 1).
    const cleaned = value.replace(/[£$€,\s]/g, '');
    const parsed = parseFloat(cleaned);
    return isNaN(parsed) ? 0 : parsed;
  }

  return 0;
};

export const formatNumber = (number: number) => {
  if (number) {
    return numeral(number).format('0,0');
  }
  return 0.0;
};

export const formatMoneyExportOrNull = (number: number | undefined | null, currencySymbol = '£') => {
  if ((number || number === 0) && numeral(number).format('0,0.00') !== 'NaN') {
    return `${currencySymbol} ${numeral(number).format('0,0.00')}`;
  }
  return '';
};